import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { ModalService } from '@freelancer/ui';
import { ModalSize } from '@freelancer/ui/modal';

@Component({
  standalone: false,
  selector: `app-two-factor-auth-secure-phone-error`,
  template: `
    <p class="text-error">
      @if (userHasChangeSecurePhoneRequest) {
        <ng-container i18n="Pending phone number change request">
          You have a pending request to change your phone number. To complete
          this request, please verify your identity.
          <fl-link
            flTrackingLabel="PhoneVerifyIdentityVerification"
            (click)="openSecurityPhoneModal()"
          >
            Verify identity
          </fl-link>
        </ng-container>
      }
      @if (!userHasChangeSecurePhoneRequest && phoneDoesNotSupportSms) {
        <ng-container i18n="Invalid MFA Phone Number alert">
          Your elected phone number cannot receive SMS messages. Please change
          it to a mobile phone number (or cell number) to receive your
          authentication token via text.
        </ng-container>
      }
    </p>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TwoFactorAuthSecurePhoneErrorComponent {
  private modalService = inject(ModalService);

  @Input() userHasChangeSecurePhoneRequest: boolean;
  @Input() phoneDoesNotSupportSms: boolean;

  openSecurityPhoneModal(): void {
    this.modalService.open('UserSettingsProfileSetupSecurityPhoneModal', {
      inputs: {
        hasPhone: true,
        hasPendingRequest: true,
      },
      mobileFullscreen: true,
      size: ModalSize.SMALL,
    });
  }
}
